import { DesignData, MediaElement } from 'editor/src/store/design/types';

// Every uuid lookup finds the first element with that uuid, so a later copy could never be selected,
// removed or refilled. The last copy is kept: it is drawn on top, so it is the one the buyer saw.
// Returns the same design when no page repeats a uuid.
function removeRepeatedUuidElements(designData: DesignData): {
  designData: DesignData;
  removed: MediaElement[];
} {
  const removed: MediaElement[] = [];
  const spreads = designData.spreads.map((spread) => {
    let spreadChanged = false;
    const pages = spread.pages.map((page) => {
      const { media } = page.groups;
      if (!media) {
        return page;
      }

      const lastIndexByUuid = new Map<number, number>();
      media.forEach((element, index) => {
        if (element.uuid !== undefined) {
          lastIndexByUuid.set(element.uuid, index);
        }
      });
      const isRepeated = (element: MediaElement, index: number) =>
        element.uuid !== undefined && lastIndexByUuid.get(element.uuid) !== index;
      if (!media.some(isRepeated)) {
        return page;
      }

      spreadChanged = true;
      removed.push(...media.filter(isRepeated));
      return {
        ...page,
        groups: {
          ...page.groups,
          media: media.filter((element, index) => !isRepeated(element, index)),
        },
      };
    });
    return spreadChanged ? { ...spread, pages } : spread;
  });

  return removed.length ? { designData: { ...designData, spreads }, removed } : { designData, removed };
}

export default removeRepeatedUuidElements;
